import { createUseStyles } from 'react-jss'
import { titleFont, regularFont, titleFontSemiBold, color, textSize } from 'styles/helpers'
import config from 'styles/config'

const titleStyle = theme => ({
  marginBottom: 16,
  ...textSize(16, 19),
  ...titleFont(),
  ...color('titleColor', theme.theme),
  '& strong': {
    ...titleFontSemiBold()
  }
})

export default createUseStyles(theme => ({
  title: {
    ...titleStyle(theme)
  },
  withStepTitle: {
    ...textSize(14, 16),
    ...color('textSecondary', theme.theme),
    ...regularFont(),
  },
  standalone: {
    marginBottom: 0,
  },

  [config.mediaQueries.tabletPortrait]: {
    withStepTitle: {
      ...titleStyle(theme)
    },
  }
}))
